/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useMutation
} from '@tanstack/react-query'
import type {
  UseMutationOptions,
  MutationFunction
} from '@tanstack/react-query'
import type {
  BeneficiaryDeedResponse,
  BeneficiaryDeedRequest
} from './schema'



export const utxBeneficiaryDownloadLatestChangeDeed = (
    beneficiaryDeedRequest: BeneficiaryDeedRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BeneficiaryDeedResponse>> => {
    return axios.post(
      `/beneficiary/latest-change-deed/download`,
      beneficiaryDeedRequest,options
    );
  }



    export type UtxBeneficiaryDownloadLatestChangeDeedMutationResult = NonNullable<Awaited<ReturnType<typeof utxBeneficiaryDownloadLatestChangeDeed>>>
    export type UtxBeneficiaryDownloadLatestChangeDeedMutationBody = BeneficiaryDeedRequest
    export type UtxBeneficiaryDownloadLatestChangeDeedMutationError = AxiosError<unknown>

    export const useUtxBeneficiaryDownloadLatestChangeDeed = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxBeneficiaryDownloadLatestChangeDeed>>, TError,{data: BeneficiaryDeedRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxBeneficiaryDownloadLatestChangeDeed>>, {data: BeneficiaryDeedRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxBeneficiaryDownloadLatestChangeDeed(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxBeneficiaryDownloadLatestChangeDeed>>, TError, {data: BeneficiaryDeedRequest}, TContext>(mutationFn, mutationOptions)
    }
    